import { render, staticRenderFns } from "./ShortPlayInfo.vue?vue&type=template&id=007c6305&scoped=true"
import script from "./ShortPlayInfo.vue?vue&type=script&lang=js"
export * from "./ShortPlayInfo.vue?vue&type=script&lang=js"
import style0 from "./ShortPlayInfo.vue?vue&type=style&index=0&id=007c6305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007c6305",
  null
  
)

export default component.exports